import { imageMediaViewPorts } from '@/constants/image';
import { ContentType } from '@/enums/content-type';
import { Banner, BannerTile } from '@cinemark/content-api-client';
import clsx from 'clsx';

type BannerImageComponentProps = {
  banner: Banner | BannerTile;
  className?: string;
  imageClassName?: string;
};

export const BannerImageComponent = ({
  banner,
  className = '',
  imageClassName = '',
}: BannerImageComponentProps): React.JSX.Element | null => {
  if (!banner) return null;

  const isTile = banner['@type'] === ContentType.BANNER_TILE;
  const tile = banner as BannerTile;
  const bannerAsBanner = banner as Banner;

  const largeSrc = banner.bannerImageLarge?.url || '';
  const mediumSrc = banner.bannerImageMedium?.url || '';
  const smallSrc = banner.bannerImageSmall?.url || '';
  const altText = isTile ? tile.tileHeading || '' : bannerAsBanner.bannerHeading || '';

  return (
    <picture className={clsx('block h-full', className)}>
      {largeSrc &&
        <source media={imageMediaViewPorts.minLarge}
          srcSet={largeSrc}
        />
      }
      {smallSrc &&
        <source srcSet={`${smallSrc}${mediumSrc ? `, ${mediumSrc} 2x` : ''}`}/>
      }
      <img alt={altText}
        className={clsx('w-full h-full object-cover', imageClassName)}
        src={mediumSrc || largeSrc || smallSrc}
        srcSet={mediumSrc}
      />
    </picture>
  );
};
